<div class="restaurant-container">
  <app-restaurant-header></app-restaurant-header>
      <!-- il banner -->
  <app-restaurant-banner></app-restaurant-banner>

  <div class="search-bar-container">
  <app-search [alwaysVisible]="true"></app-search>
</div> 

  <div class="main-content">
      <ng-container *ngFor="let resturantMenu of resturantMenuCards">
      <div class="menu-card-wrapper" (click)="vaiAllaLista(resturantMenu.codicefamiglia)">
        <app-menu-card
          [title]="resturantMenu.descrizione"
          [image]="resturantMenu.img"
        ></app-menu-card>
      </div>
    </ng-container>

     <ng-template #loadingShimmer>
    <app-loading-shimmer></app-loading-shimmer>
  </ng-template>
  </div>
  
  <div class="bottom-indicator">
    <div class="indicator-line"></div>
  </div>
    <app-restaurant-footer></app-restaurant-footer>
</div>

